const WindowService = {
    showEmailWindow: (mailTo = "", subject = "Temat", body = "") => {
        let mailToString = `mailto:${mailTo}?`;
        if (subject.length > 0) {
            mailToString = `${mailToString}subject=${subject}&body=${encodeURIComponent(body)}`;
        } else {
            mailToString = `${mailToString}body=${encodeURIComponent(body)}`;
        }
        window.open(mailToString, "_self", "PopUp1");
    },
    openInNewTab: (url) => {
        window.open(url, "_blank").focus();
    },
};

export default WindowService;
